<template>
  <div class="download-btn">
    <v-btn icon :disabled="disabled"
      @click="test"
    >
    <v-icon color="primary">cloud_download</v-icon>

    </v-btn>
  </div>
</template>
<script>
import Download from 'downloadjs';
export default {
  name: 'download-csv',
  props: {
    data: {
      type: Array,
      required: false,
      default: () => []
    },
    filename: {
      type: String,
      required: false,
      default: () => 'export.csv'
    },
    disabled: {
      type: Boolean,
      required: false,
      default: () => false
    },
    delimiter: {
      type: String,
      default: ',',
      required: false
    },
    separatorExcel: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      stockData: [
        {
          Symbol: 'AAPL',
          Company: 'Apple Inc.',
          Price: '132.54'
        }
      ]
    };
  },
  methods: {
    test () {
      console.log('test', this.downloadCSV({filename: this.filename}));
    },
    downloadCSV (args) {
      // var data;
      var filename;
      console.log('downloadCSV', this.data);

      var csv = this.convertCSV({
        data: this.data
      });
      if (csv == null) return;

      filename = (args && args.filename) || 'export.csv';

      // data = encodeURI(csv);

      if (this.separatorExcel) {
        csv = 'SEP=' + this.delimiter + '\r\n' + csv;
      }
      Download(csv, filename, 'application/csv');

      return {
        data: csv,
        filename: filename
      }
    },
    convertCSV (args) {
      var result;
      var ctr;
      var keys;
      var columnDelimiter;
      var lineDelimiter;
      var data;

      data = args.data || null;
      if (data == null || !data.length) {
        return null;
      }
      console.log('convertCSV', data);
      columnDelimiter = args.columnDelimiter || ',';
      lineDelimiter = args.lineDelimiter || '\n';

      keys = Object.keys(data[0]);

      result = '';
      result += keys.join(columnDelimiter);
      result += lineDelimiter;

      data.forEach(function (item) {
        ctr = 0;
        keys.forEach(function (key) {
          if (ctr > 0) result += columnDelimiter;

          result += item[key];
          ctr++;
        });
        result += lineDelimiter;
      });

      return result;
    }
  }
};
</script>
<style>

</style>


